<div fxLayout="column" fxLayoutGap="20px">
    <div fxLayout="row" fxLayoutAlign="end center" class="mb-0">
        <mat-icon style="cursor: pointer;" mat-dialog-close>close</mat-icon>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="30px">
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="0px">
            <label mat-dialog-title class="otpHeader">Forgot Password?</label>
            <p class="pararagraphLine text-center px-5">Enter your email address to request a password reset</p>
        </div>
        <div class="col-12">
            <input type="text" [(ngModel)]="mailId" placeholder="Enter your email ID" style="width: inherit;" />
            <label *ngIf="errorText" class="errorTextmsg">Please enter a registered email id</label>
        </div>
        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">
            <button type="button" class="btn add btn-primary" (click)="onVerify()">Send Reset Link</button>
            <p class="resendText">Did not receive Code?<a (click)="onVerify()" class="text-inherit fw-semi-bold"
                    style="cursor:pointer;text-decoration: none;">&nbsp; Resend</a>
            </p>
        </div>
    </div>
</div>